import { render, staticRenderFns } from "./dataDictionary.vue?vue&type=template&id=09af3344&scoped=true&"
import script from "./dataDictionary.vue?vue&type=script&lang=js&"
export * from "./dataDictionary.vue?vue&type=script&lang=js&"
import style0 from "./dataDictionary.vue?vue&type=style&index=0&id=09af3344&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09af3344",
  null
  
)

export default component.exports